import { createContext } from "react"

const breadcrumbContext = createContext()
export default breadcrumbContext
